/** @flow */

import {
  GetDynamicQuestions,
  GetDynamicQuestionsSuccess,
  GetDynamicQuestionsError,
  GetDynamicQuestion,
  GetDynamicQuestionSuccess,
  GetDynamicQuestionError,
  NewDynamicQuestion,
  ShowAddDynamicQuestionModal,
  UpdateDynamicQuestionDraft,
  SetDynamicQuestionRevisionSchema,
  GetDynamicQuestionActiveSuccess,
  GetDynamicQuestionActiveError,
  SetDynamicQuestionAssignments,
  SetDynamicQuestionStatus,
  ShowDynamicQuestionEditModal,
  SetShowSubmitDynamicQuestionModal,
  SubmitDynamicQuestionForReviewError,
  SetShowCancelDynamicQuestionModal,
  CancelDynamicQuestionReviewError,
  StartDynamicQuestionDraftSuccess,
  SetShowDiscardDynamicQuestionModal,
  SetShowCancelDiscardDynamicQuestionModal,
  DuplicateDynamicQuestionSuccess,
  SetShowDisableDynamicQuestionModal,
  StartDynamicQuestionDraftError,
  DiscardDynamicQuestionDraftError,
  DuplicateDynamicQuestionError,
  CancelDynamicQuestionReviewAndDiscardError,
  DisableDynamicQuestionError,
  UpdateDynamicQuestionAssignmentsError,
  ShowEditDynamicQuestionAssignmentsModal,
  SetDynamicQuestionDraftAssignments,
  UpdateDynamicQuestion,
  UpdateDynamicQuestionSuccess,
  UpdateDynamicQuestionError,
  AddNewDynamicQuestion,
  AddNewDynamicQuestionSuccess,
  AddNewDynamicQuestionError,
} from "@modules/service/constants/actions";
import * as dynamicQuestionsReducers from "./reducers";
import initialState from "./state";
import type { DynamicQuestionsState } from "./types";
import { cloneObject } from "@utils/object";

export default (
  state: DynamicQuestionsState = initialState,
  action: Object,
): DynamicQuestionsState => {
  const act = {
    [AddNewDynamicQuestion]: dynamicQuestionsReducers.onAddNewDynamicQuestion,
    [AddNewDynamicQuestionSuccess]: dynamicQuestionsReducers.onAddNewDynamicQuestionSuccess,
    [AddNewDynamicQuestionError]: dynamicQuestionsReducers.onAddNewDynamicQuestionError,
    [UpdateDynamicQuestion]: dynamicQuestionsReducers.onUpdateDynamicQuestion,
    [UpdateDynamicQuestionSuccess]: dynamicQuestionsReducers.onUpdateDynamicQuestionSuccess,
    [UpdateDynamicQuestionError]: dynamicQuestionsReducers.onUpdateDynamicQuestionError,
    [GetDynamicQuestions]: dynamicQuestionsReducers.onGetDynamicQuestions,
    [GetDynamicQuestionsSuccess]: dynamicQuestionsReducers.onGetDynamicQuestionsSuccess,
    [GetDynamicQuestionsError]: dynamicQuestionsReducers.onGetDynamicQuestionsError,
    [NewDynamicQuestion]: dynamicQuestionsReducers.onNewDynamicQuestion,
    [ShowAddDynamicQuestionModal]: dynamicQuestionsReducers.onShowAddDynamicQuestionModal,
    [UpdateDynamicQuestionDraft]: dynamicQuestionsReducers.onUpdateDynamicQuestionDraft,
    [SetDynamicQuestionRevisionSchema]: dynamicQuestionsReducers.onSetDynamicQuestionRevisionSchema,
    [GetDynamicQuestionActiveSuccess]: dynamicQuestionsReducers.onGetDynamicQuestionActiveSuccess,
    [GetDynamicQuestionActiveError]: dynamicQuestionsReducers.onGetDynamicQuestionActiveError,
    [SetDynamicQuestionAssignments]: dynamicQuestionsReducers.onSetDynamicQuestionAssignments,
    [SetDynamicQuestionDraftAssignments]:
      dynamicQuestionsReducers.onSetDynamicQuestionDraftAssignments,

    [SetDynamicQuestionStatus]: dynamicQuestionsReducers.onSetDynamicQuestionStatus,
    [GetDynamicQuestion]: dynamicQuestionsReducers.onGetDynamicQuestion,
    [GetDynamicQuestionSuccess]: dynamicQuestionsReducers.onGetDynamicQuestionSuccess,
    [GetDynamicQuestionError]: dynamicQuestionsReducers.onGetDynamicQuestionError,
    [ShowDynamicQuestionEditModal]: dynamicQuestionsReducers.onShowDynamicQuestionEditModal,
    [SetShowSubmitDynamicQuestionModal]:
      dynamicQuestionsReducers.onSetShowSubmitDynamicQuestionModal,
    [SetShowCancelDynamicQuestionModal]:
      dynamicQuestionsReducers.onSetShowCancelDynamicQuestionModal,
    [SubmitDynamicQuestionForReviewError]:
      dynamicQuestionsReducers.onSubmitDynamicQuestionForReviewError,
    [CancelDynamicQuestionReviewError]: dynamicQuestionsReducers.onCancelDynamicQuestionReviewError,
    [StartDynamicQuestionDraftSuccess]: dynamicQuestionsReducers.onStartDynamicQuestionDraftSuccess,
    [SetShowDiscardDynamicQuestionModal]:
      dynamicQuestionsReducers.onSetShowDiscardDynamicQuestionModal,
    [SetShowCancelDiscardDynamicQuestionModal]:
      dynamicQuestionsReducers.onSetShowCancelDiscardDynamicQuestionModal,
    [DuplicateDynamicQuestionSuccess]: dynamicQuestionsReducers.onDuplicateDynamicQuestionSuccess,
    [SetShowDisableDynamicQuestionModal]:
      dynamicQuestionsReducers.onSetShowDisableDynamicQuestionModal,
    [StartDynamicQuestionDraftError]: dynamicQuestionsReducers.onStartDynamicQuestionDraftError,
    [DiscardDynamicQuestionDraftError]: dynamicQuestionsReducers.onDiscardDynamicQuestionDraftError,
    [DuplicateDynamicQuestionError]: dynamicQuestionsReducers.onDuplicateDynamicQuestionError,
    [CancelDynamicQuestionReviewAndDiscardError]:
      dynamicQuestionsReducers.onCancelDynamicQuestionReviewAndDiscardError,
    [DisableDynamicQuestionError]: dynamicQuestionsReducers.onDisableDynamicQuestionError,
    [UpdateDynamicQuestionAssignmentsError]:
      dynamicQuestionsReducers.onUpdateDynamicQuestionAssignmentsError,
    [ShowEditDynamicQuestionAssignmentsModal]:
      dynamicQuestionsReducers.onShowEditDynamicQuestionAssignmentsModal,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
